<template>
  <label
    class="achievement-item"
    :class="getClassObject"
    @click="handleItemClick"
  >
    <!-- 考试item复选框 -->
    <el-checkbox
      class="check-box"
      :label="examInfo.id"
      v-model="isChecked"
      v-if="itemType == 'grade'"
    ></el-checkbox>
    <el-checkbox
      class="check-box"
      :label="examInfo.classId"
      v-model="isChecked"
      v-else
    ></el-checkbox>
    <!-- 考试信息 -->
    <div class="achievement-item-content">
      <div class="achievement-item-content-title">
        <span class="grade-name">{{ examInfo.gradeName }}</span>
        <span class="grade-name" v-if="itemType == 'class'">{{
          examInfo.className
        }}</span>
        <span class="achievement-title"
          >{{ examInfo.title }}/{{ examInfo.subTitle }}/</span
        >
        <span class="school-year"
          >{{ examInfo.schoolYear }}学年{{
            examInfo.semester == "1" ? "第一学期" : "第二学期"
          }}</span
        >
      </div>
      <div class="achievement-item-content-desc">
        <span class="external" v-if="itemType == 'grade'"
          >是否对外：{{ examInfo.isExternal == "0" ? "否" : "是" }}</span
        >
        <span class="external" v-if="itemType == 'class'"
          >排名：({{ examInfo.rank || "无" }})</span
        >
        <span class="time"
          >时间：{{ examInfo.startTime }} —— {{ examInfo.endTime }}</span
        >
      </div>
      <div class="achievement-item-content-score">
        <span class="totalScore" v-if="examInfo.totalScore"
          >总分：{{ examInfo.totalScore }}</span
        >
        <span v-if="examInfo.avgScore">平均分：{{ examInfo.avgScore }}</span>
      </div>
    </div>
    <!-- 按钮列表 -->
    <div class="btn-list">
      <el-button size="mini" class="btn" @click.stop="jumpStudentRank"
        >查看学生排行</el-button
      >
      <!-- 年级考试才显示的按钮 -->
      <el-button
        size="mini"
        class="btn"
        v-if="itemType == 'grade'"
        @click.stop="viewClassExam"
      >
        查看班级考试
      </el-button>
      <el-button
        size="mini"
        class="btn"
        v-if="itemType == 'grade'"
        @click.stop="rankingUpdate"
      >
        排名更新<span v-if="examInfo.rankUpdateTime"
          >-最后更新于{{ examInfo.rankUpdateTime }}</span
        >
      </el-button>
    </div>
    <!-- 展开的内容 -->
    <transition name="fade">
      <div v-show="isUnfold" v-loading="loading">
        <el-divider></el-divider>
        <div class="unfold-content" v-if="tableData.length">
          <!-- <div class="switch-text" @click.stop="tableShowSwitch">查看视图</div> -->
          <el-button
            v-hasPermi="'sc:score:export'"
            class="derive-text"
            type="text"
            @click="derivedIndex"
            >导出指标</el-button
          >
          <el-button
            class="switch-text"
            type="text"
            @click.stop="tableShowSwitch"
            >查看视图</el-button
          >
          <el-tooltip
            effect="dark"
            content="指标值为-1表示未设置该科目指标"
            placement="bottom-start"
          >
            <i class="el-icon-question icon-question"></i>
          </el-tooltip>
          <!-- 各维度表格 -->
          <el-table :data="tableData" class="table" max-height="210">
            <el-table-column prop="courseName" label="科目" width="50">
            </el-table-column>
            <el-table-column
              prop="avgScore"
              label="平均分"
              :width="columnWidth"
            >
            </el-table-column>
            <el-table-column
              prop="fullMarkRate"
              label="满分率"
              :width="columnWidth"
            >
            </el-table-column>
            <el-table-column
              prop="overallPassRate"
              label="及格率"
              :width="columnWidth"
            >
            </el-table-column>
            <el-table-column
              prop="overtopAverageRate"
              label="超均率"
              :width="columnWidth"
            >
            </el-table-column>
            <el-table-column
              prop="standardDeviation"
              label="标准差"
              :width="columnWidth"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in descList"
              :key="index"
              :label="item.desc"
            >
              <template slot-scope="{ row }">
                <!-- <span> {{ item.descRate || '无' }}</span> -->
                <span
                  v-if="row.descList.find((dItem) => dItem.desc === item.desc)"
                >
                  {{
                    row.descList &&
                    row.descList.find((dItem) => dItem.desc === item.desc)
                      ?.descRate
                  }}</span
                >
                <span v-else>0</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-empty v-else description="成绩未录入" :image-size="100"></el-empty>
      </div>
    </transition>

    <!-- 展开切换的icon -->
    <div class="unfold-icon" v-hasPermi="'sc:coursegrade:query'">
      <el-button
        v-show="!isUnfold"
        @click.stop="isUnfoldChange"
        type="text"
        icon="el-icon-arrow-down"
      ></el-button>
      <el-button
        v-show="isUnfold"
        @click.stop="isUnfoldChange"
        type="text"
        icon="el-icon-arrow-up"
      ></el-button>
      <!-- <i
        v-show="!isUnfold"
        @click.stop="isUnfoldChange"
        class="el-icon-arrow-down"
      ></i>
      <i
        v-show="isUnfold"
        @click.stop="isUnfoldChange"
        class="el-icon-arrow-up"
      ></i> -->
    </div>
  </label>
</template>

<!-- 此组件用于成绩分析的年级考试与班级考试列表item -->
<script>
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: ["itemType", "examInfo"], // item类型(年级，班级)
  data() {
    return {
      isUnfold: false, // 是否展开状态
      tableShow: true, // 表格或柱状图显示切换
      tableData: [],
      descList: [], // 动态的维度列表
      loading: false,
      isChecked: false, // 新增数据属性来管理复选框状态
      columnWidth: 63,
    };
  },
  computed: {
    // 展开时添加development-height的样式
    getClassObject() {
      return {
        "development-height": this.isUnfold,
      };
    },
  },
  methods: {
    // 导出指标
    derivedIndex() {
      let action;
      if (this.itemType == "grade") {
        action = `${baseURL}${this.$url.examDimensionDetailsExcelPC}?examInfoId=${this.examInfo.id}&gradeId=${this.examInfo.gradeId}`;
      } else {
        action = `${baseURL}${this.$url.examDimensionDetailsExcelPC}?examInfoId=${this.examInfo.id}&classId=${this.examInfo.classId}`;
      }
      window.open(action);
    },
    handleItemClick() {
      // 点击achievement-item时更新isChecked的值，Vue 的响应式系统会处理视图更新
      this.isChecked = !this.isChecked;
    },
    // 排名更新
    rankingUpdate() {
      this.get(`${this.$url.rankingUpdate}/${this.examInfo.id}`).then((res) => {
        if (res.code !== 200)
          return this.$message.error(res.msg || "成绩未录入");
        this.$message.success(res.msg || "更新成功");
      });
    },
    // 点击展开时获取年级班级的维度数据
    isUnfoldChange() {
      this.isUnfold = !this.isUnfold;
      if (!this.isUnfold) return;

      const data = {
        examInfoId: this.examInfo.id,
        // gradeId: this.examInfo.gradeId,
      };

      if (this.itemType === "class") {
        data.classId = this.examInfo.classId;
        this.selectExamLatitudeByPC(data, this.$url.selectExamDimensionDetails);
      } else {
        data.gradeId = this.examInfo.gradeId;
        this.selectExamLatitudeByPC(data, this.$url.selectExamDimensionDetails);
      }
    },
    selectExamLatitudeByPC(data, url) {
      this.loading = true;
      this.post(url, data)
        .then((res) => {
          if (res.code !== 200) {
            this.loading = false;
            return;
          }
          this.tableData = res.data;
          this.tableData.forEach((cItem) => {
            cItem.descList.forEach((item) => {
              if (!this.descList.find((dItem) => dItem.desc === item.desc)) {
                this.descList.push(item);
              }
            });
          });
          this.loading = false;
        })
        .catch((error) => {
          // 处理错误
          console.error("Error:", error);
          this.loading = false;
        });
    },
    // 点击班级考试
    viewClassExam() {
      this.$emit("viewClassExam", this.examInfo);
    },
    tableShowSwitch() {
      // this.tableShow = !this.tableShow;
      this.$emit("chartDialogShow", this.tableData);
    },
    jumpStudentRank() {
      let data = {
        itemType: this.itemType,
        examInfo: this.examInfo,
      };
      this.$emit("jumpStudentRank", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementItem.scss";
</style>